import Text from 'components/commons/Text';
import LocalizeEditor from 'components/input/LocalizeEditor';
import LocalizeInput from 'components/input/LocalizeInput';
import UploadButton from 'components/input/UploadButton';
import { InnerSection } from 'components/layouts/CommonForm';
import { InnerGroup } from 'components/layouts/CommonForm';
import IconButton from 'controls/IconButton';
import React from 'react';
import { toast } from 'react-toastify';
import { Button, Row, useModelStateContext } from 'saladsoft-primitive';
import { AdminPromotionDto, AdminPromotionRequestDto } from 'services/data-contracts';
import ServiceHelper from 'stores/ServiceHelper';
import { useStoreWrapper } from 'stores/StoreHelper';
import styled from 'styled-components';

const PromotionView = ({
  promotion,
  onSave,
  onChange,
}: {
  promotion?: AdminPromotionDto;
  onSave?: () => void;
  onChange?: () => void;
}) => {
  const { uiStore } = useStoreWrapper();

  const handleClickDelete = () => {
    uiStore?.confirm.show({
      title: '정말 삭제하시겠습니까?',
      onConfirmed: () => {
        ServiceHelper.adminPromotionService
          ?.deletePromotion(promotion?.id as number)
          .then((res) => {
            toast.success('프로모션이 삭제되었습니다.');
            uiStore?.modal.close();
            onSave?.();
          });
      },
    });
  };

  return (
    <div style={{ padding: 20 }}>
      <ImgWrapper>
        <img src={promotion?.images?.[0]?.url} />
      </ImgWrapper>
      <div>
        <Text type="H2" style={{ padding: '20px 0' }}>
          {promotion?.localizedTitle?.ko}
        </Text>
        <Row gap={10} width="100%" justifyContent="flex-start">
          <div>장소 : </div>
          <Text type="H4">{promotion?.localizedAddress?.ko}</Text>
        </Row>
        <Row gap={10} width="100%" justifyContent="flex-start">
          <div>기간 : </div>

          <Text type="H4">{promotion?.localizedPeriod?.ko}</Text>
        </Row>
        <hr />
        <div
          dangerouslySetInnerHTML={{ __html: promotion?.localizedDesc?.ko || '' }}
          style={{ marginTop: 20 }}
        />
      </div>
      <Row justifyContent="space-between" alignContent="center" gap={10}>
        <Row gap={10}>
          <Button
            style={{ marginTop: 20 }}
            onClick={() => {
              onChange?.();
            }}
          >
            프로모션 수정
          </Button>
          <Button
            type="outlined"
            style={{ marginTop: 20 }}
            onClick={async () => {
              uiStore?.modal.close();
            }}
          >
            닫기
          </Button>
        </Row>
        <div>
          <IconButton
            type="delete"
            onClick={() => {
              handleClickDelete();
            }}
          />
        </div>
      </Row>
    </div>
  );
};

const ImgWrapper = styled.div`
  width: 100%;
  height: 100%;
  img {
    width: 100%;
  }
`;

export default PromotionView;
